import { Fragment } from "react";

const AboutPage = () => {
    return <Fragment>
        <p>Some info about me...</p>
    </Fragment>

};

export default AboutPage;